import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Stack } from 'react-bootstrap';
// import '../../Scss/Form.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import RHFTextField from '../../FunctionalComponent/FormElement/RHTextField';
import FormProvider from '../../FunctionalComponent/FormElement/FormProvider';
import RHSelectField from '../../FunctionalComponent/FormElement/RHSelectField';
import { useCreate_Update_sizeMutation, useGetsizeMutation } from '../../Redux/SizeSlice';
import { useDispatch, useSelector } from 'react-redux';
// import { Chip } from '@mui/material';
import Select from 'react-select';
import { useCreateSpecificationMutation, useGetSpecificationsTypeQuery } from '../../Redux/specification/specificationApi';




const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },
];

function CreateSpecification(props) {
    const { setOpen, SizeData, open } = props;
    const [CreateUpdateSizeFunc] = useCreate_Update_sizeMutation();
    const [GetsizeFunc] = useGetsizeMutation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [chipsOptions, setChipsOptions] = useState([])


    const { data: specificationsTypeData } = useGetSpecificationsTypeQuery()

    let title = {
        header: `Specification ${SizeData?.id ? 'Update' : 'Add'}`,
        submit: `${SizeData?.id ? 'Update' : 'Save'}`
    };

    let initialState = {
        specificationTypeId: '',
        value: [],
        status: true
    };

    // const schema = Yup
    //     .object({
    //         name: Yup
    //             .string()
    //             .required()
    //             .strict(true)
    //             .trim('White spaces before and after are not allow'),
    //         slug: Yup
    //             .string()
    //             .required()
    //             .strict(true)
    //             .trim('White spaces before and after are not allow'),
    //         // status: Yup.string().required(),
    //         status: Yup.string().required('Status is required'),
    //     })
    //     .required();

    const methods = useForm({
        // resolver: yupResolver(schema),
        defaultValues: initialState,
        mode: 'all',
    });
    const {
        handleSubmit,
        reset,
        setError,
        setValue,
        getValues,
    } = methods;

    const [fn, { }] = useCreateSpecificationMutation()

    const onSubmit = (e) => {
        const data = getValues();
        if (data?.specificationTypeId) {
            fn({ ...data, value: chipsOptions, status: true }).then(async (res) => {
                if (res?.data?.statusCode == 201) {
                    setOpen(false)
                }
            })
        }
    }
    const handleDelete = () => {
        console.info('You clicked the delete icon.');
    };
    useEffect(() => {
        if (SizeData?.id) {
            GetsizeFunc(SizeData?.id).then(res => {
                const getsizedata = res?.data?.response
                Object.keys(initialState).forEach((fieldname) => {
                    setValue(fieldname, getsizedata[`${fieldname}`]);
                })

            })
        }
    }, [SizeData?.id])

    const handleClose = () => {
        setOpen(false);
    };

    // const [chips, setChips] = useState([]);
    const [inputValue, setInputValue] = useState('');

    const handleInputChange = (newValue) => {
        setInputValue(newValue);
        return false

    };


    const [options, setOptions] = useState([]);

    const handleKeyDown = (event) => {
        console.log('event handleKeyDown', event);
        if (event.key === 'Enter' && inputValue.trim() !== '') {
            setOptions([...options, { value: inputValue, label: inputValue }]);
            setChipsOptions(pre => ([...pre, { value: inputValue, label: inputValue }]))

            setInputValue('');
            event.preventDefault();
            return false
        }
        return false
    };


    const handleRemove = (removedValue) => {
        const updatedOptions = options.filter((option) => option.value !== removedValue.value);
        const updatedChipsOptions = chipsOptions.filter((option) => option.value !== removedValue.value);

        setOptions(updatedOptions);
        setChipsOptions(updatedChipsOptions);
    };
    return (
        <>
            <Modal id="showModal" className="fade zoomIn" size="md" title={title}
                show={open} onHide={() => { setOpen(!open) }} centered>
                <Modal.Header className="px-4 pt-4" closeButton>
                    <h5 className="modal-title fs-18" id="exampleModalLabel">Add Specification</h5>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <FormProvider className="tablelist-form" methods={methods}  >
                        <Row>
                            <div id="alert-error-msg" className="d-none alert alert-danger py-2"></div>
                            <input type="hidden" id="id-field" />
                            <Col lg={12}>
                                <div className="mb-3">
                                    <RHSelectField
                                        name='specificationTypeId'
                                        label='Specification Name'
                                        required={true}
                                        list={specificationsTypeData?.response?.map(it => ({ name: it?.name, value: it?.id }))}
                                    />
                                </div>
                            </Col>

                            <Col lg={12}>
                                <div className="mb-3">
                                    <Form.Label htmlFor="product-title-input" required>Value</Form.Label>

                                </div>
                                <Select
                                    isMulti
                                    type='button'
                                    options={options}
                                    inputValue={inputValue}
                                    onInputChange={handleInputChange}
                                    onKeyDown={handleKeyDown}
                                    placeholder="Select options"
                                    components={{
                                        MultiValueRemove: ({ innerProps, data }) => (
                                            <div {...innerProps} onClick={() => handleRemove(data)}>
                                                &times;
                                            </div>
                                        ),
                                    }}

                                    value={chipsOptions}
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            border: '1px solid #ced4da',
                                            borderRadius: '0.25rem',
                                            boxShadow: 'none',
                                            '&:hover': {
                                                borderColor: '#ced4da',
                                            },
                                        }),
                                        multiValueLabel: (provided) => ({
                                            ...provided,
                                            color: '#fff',
                                            backgroundColor: '#007bff',
                                        }),
                                        multiValueRemove: (provided) => ({
                                            ...provided,
                                            color: '#fff',
                                            backgroundColor: '#007bff',
                                            borderRadius: '0.25rem',
                                            '&:hover': {
                                                backgroundColor: '#0056b3',
                                            },
                                        }),
                                    }}
                                />

                            </Col>
                            {/* <Col lg={6}>
                                <div className="hstack gap-3 align-items-start">
                                    <div className="flex-grow-1">
                                        <Form.Control
                                            data-choices
                                            data-choices-multiple-remove="true"
                                            placeholder="Enter tags"
                                            type="text"
                                            defaultValue="Cotton"
                                        />
                                    </div>
                                </div>
                            </Col> */}
                            {/* <Col lg={6}>
                                <div className='d-flex'>
                                    {
                                        chips.map(it => (
                                            <div className='bg-info'>
                                                {it}
                                            </div>
                                        ))
                                    }
                                </div>

                                <input value={chipsInput} onChange={e => setChipsInput(e.target.value)} onKeyDown={e => {
                                    if (e.key === 'Enter') {
                                        setChips(prev => ([...prev, chipsInput]));
                                        setChipsInput('')
                                    }
                                }} type="text" className='form-control' />
                            </Col> */}


                            <Col lg={12} className="modal-footer">
                                <div className="hstack gap-2 justify-content-end">
                                    <Button className="btn-ghost-danger" onClick={() => { setOpen(!open) }}><i className="ri-close-line align-bottom me-1"></i> Close</Button>
                                    <Button variant='primary' id="add-btn" onClick={onSubmit} type="button">Save</Button>
                                </div>
                            </Col>
                        </Row>
                    </FormProvider>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default CreateSpecification;
